import React from 'react';
import { Box, Button, Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '10px',
    padding: '12px 16px',
    textAlign: 'center'
  },
  title: {
    fontWeight: 600,
    color: theme.palette.error.main
  },
  message: {
    marginTop: '4px',
    color: '#5f6368'
  },
  retry: {
    marginTop: '10px'
  },
  empty: {
    width: '100%',
    height: '24px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.primary.main,
    marginTop: '10px'
  }
}));

// Explicit failure state for a history/report request. `error` comes from
// features/historyError.js. Temporary outages (503 HISTORY_TIER_UNAVAILABLE)
// are worded as "try again later"; everything else as a plain load failure.
export const HistoryErrorState = ({ error, onRetry, heading }) => {
  const classes = useStyles();
  if (!error) return null;
  return (
    <Box className={classes.root} role="alert" data-testid="history-error">
      <Typography className={classes.title}>
        {heading ||
          (error.temporary
            ? 'Dữ liệu tạm thời chưa truy cập được'
            : 'Không thể tải dữ liệu')}
      </Typography>
      <Typography variant="body2" className={classes.message}>
        {error.message}
      </Typography>
      {onRetry && (
        <Button
          variant="outlined"
          color="primary"
          size="small"
          className={classes.retry}
          onClick={onRetry}
        >
          Thử lại
        </Button>
      )}
    </Box>
  );
};

// Drop-in for the old `Không có dữ liệu` div: a failed request shows the error
// state, only a successful-but-empty result shows the empty text.
export const HistoryEmptyOrError = ({
  error,
  onRetry,
  emptyClassName,
  emptyText = 'Không có dữ liệu'
}) => {
  const classes = useStyles();
  if (error) return <HistoryErrorState error={error} onRetry={onRetry} />;
  return <div className={emptyClassName || classes.empty}>{emptyText}</div>;
};

export default HistoryErrorState;
